export const knowledgeBaseHomepageLink = 'https://help.brandfolder.com/hc/en-us';
export const historyLogLink = 'https://help.brandfolder.com/hc/en-us/articles/13664386046487';
export const userPermissionsLink = 'https://help.brandfolder.com/hc/en-us/articles/115002602273-User-Permissions';
export const userGroupsKnowledgeBaseLink = 'https://help.brandfolder.com/hc/en-us/articles/9199616080279';
export const dependentCustomFieldsKnowledgeBaseLink = 'https://help.brandfolder.com/hc/en-us/articles/13735397807895';
